import { SButton, SIconButton, SInputLabel, STitleContainer, STitleH3 } from './common/BCommonComponents';
import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Dialog, DialogActions, DialogContent, DialogContentText, FormControl, Grid, MenuItem, Paper, Select, Table, TableBody, TableContainer, TextField } from '@material-ui/core';
import { FaSearch } from 'react-icons/all';
import TablePagination from '@material-ui/core/TablePagination';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import AuthContext from './auth/AuthContext';
import { ActivityStatus, PrestazioneConfigDTO, PrestazioneDTO, PrestazioneFilterDTO, PuntoServizioDTO, SubTaskDTO, TipoPrestazione, UserDTO, UserRole } from './common/Dtos';
import { HeadCell, Order, STableHeader, STablePaginationContainer } from './common/ScrivaniaTable';
import { RiAddFill } from 'react-icons/ri';
import { PrestazioneContattoRow } from './prestazioniTable/PrestazioneContatto';
import { InserimentoPrestazioneDialog } from './InserimentoPrestazioneDialog';
import { dateToIso, dateToIsoMantainTime } from './common/DateUtils';
import RouteLeavingGuard from './RouteLivingGuard';
import { Location } from 'history';
import axios from 'axios';
import LuxonUtils from '@date-io/luxon';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

export function Backoffice() {
	const auth = useContext(AuthContext);
	const [prestazioniList, setPrestazioniList] = useState<PrestazioneDTO[]>([]);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [totalRow, setTotalRow] = useState(0)
	const [order, setOrder] = useState<Order>('desc');
	const [orderBy, setOrderBy] = useState<string>('start_date');
	const [operatori, setOperatori] = useState<UserDTO[]>([]);
	const [puntiServizioList, setPuntiServizioList] = useState<PuntoServizioDTO[]>([]);
	const [openDialog, setOpenDialog] = useState(false);
	const [openDialogOperatore, setOpenDialogOperatore] = useState(false);
	const [prestazioneModificaOperatore, setPrestazioneModificaOperatore] = useState<PrestazioneDTO>();
	const [prestazioneInCorso, setPrestazioneInCorso] = useState<string>('');
	const [filter, setFilter] = useState<PrestazioneFilterDTO>({
		statoPrestazione: [ActivityStatus.WAIT],
		operatore: 'ALL',
		codicePrestazione: '',
		date: '',
		tipoPrestazione: [TipoPrestazione.BACKOFFICE, TipoPrestazione.FRONTOFFICE, TipoPrestazione.CALL_CENTER, TipoPrestazione.MAIL],
		puntoServizio: auth.state.roles && auth.state.roles.indexOf(UserRole.OPERATOR) > -1 && auth.state.puntoServizioLogged
			? auth.state.puntoServizioLogged?.id
			: 'ALL'
	})

	const [headCells, setHeadCells] = useState<HeadCell[]>([
		{id: 'tipo', numeric: false, disablePadding: false, label: '', sortable: false},
		{id: 'start_date', numeric: false, disablePadding: true, label: 'DATA', sortable: true},
		{id: 'codice', numeric: false, disablePadding: true, label: 'CODICE PRESTAZIONE', sortable: true},
		{id: 'name', numeric: false, disablePadding: true, label: 'PRESTAZIONE', sortable: true},
		{id: 'descrizione', numeric: false, disablePadding: false, label: 'DESCRIZIONE', sortable: true},
		{id: 'action', numeric: false, disablePadding: false, label: '', sortable: false}
	]);

	useEffect(() => {
		if (auth.state.roles && (auth.state.roles.indexOf(UserRole.SUPERVISOR) > -1
			|| auth.state.roles.indexOf(UserRole.RESPONSIBLE) > -1
			|| auth.state.roles.indexOf(UserRole.ADMIN) > -1)) {
			getCombo();
			setHeadCells([
				{id: 'tipo', numeric: false, disablePadding: false, label: '', sortable: false},
				{id: 'start_date', numeric: false, disablePadding: true, label: 'DATA', sortable: true},
				{id: 'codice', numeric: false, disablePadding: false, label: 'CODICE PRESTAZIONE', sortable: true},
				{id: 'name', numeric: false, disablePadding: true, label: 'PRESTAZIONE', sortable: true},
				{id: 'descrizione', numeric: false, disablePadding: false, label: 'DESCRIZIONE', sortable: true},
				{id: 'operatore', numeric: false, disablePadding: true, label: 'OPERATORE', sortable: true},
				{id: 'puntoServizioName', numeric: false, disablePadding: false, label: 'PUNTO DI SERVIZIO', sortable: true},
				{id: 'action', numeric: false, disablePadding: false, label: '', sortable: false}
			]);
		}
	}, [])

	useEffect(() => {
		getAll();
	}, [page, rowsPerPage, order, orderBy, openDialog]);

	useEffect(() => {
		if (prestazioneInCorso === '') {
			window.onbeforeunload = null;
		} else {
			window.onbeforeunload = (event: BeforeUnloadEvent) => {
				return "Attenzione! Il contatto non è ancora concluso! Confermi di voler uscire dalla pagina (non sarà possibile concludere il contatto in seguito)?";
			}
		}
	}, [prestazioniList, totalRow, filter, prestazioneInCorso, headCells, prestazioneModificaOperatore])

	useEffect(() => {
	}, [openDialogOperatore])

	const getCombo = () => {
		axios.all([
			auth.state.axiosInstance?.get('/api/puntoServizio/utenti/' + auth.state.puntoServizioLogged?.id),
			auth.state.axiosInstance?.get('/api/puntoServizio/punto_servizio_by_cooperativa/' + auth.state.cooperativa + '?login=' + false)
		])
			.then(axios.spread((res1, res2) => {
				setOperatori(res1?.data)
				setPuntiServizioList(res2?.data);
			})).catch(error => {
			toast.error('🛑 Errore durante il recupero degli operatori e dei punti di servizio!');
			console.log(error);
		});
	}

	const getAll = () => {
		const qs = require('qs');
		auth.state.axiosInstance?.get('/api/prestazione/prestazioni/back_office',
			{
				params: {
					statoPrestazione: [...filter.statoPrestazione],
					operatore: filter.operatore === 'ALL' ? '' : filter.operatore,
					codicePrestazione: filter.codicePrestazione,
					date: dateToIso(filter.date),
					tipoPrestazione: TipoPrestazione.BACKOFFICE,
					puntoServizio: filter.puntoServizio === 'ALL' ? '' : filter.puntoServizio,
					page: page,
					size: rowsPerPage,
					sort: orderBy + ',' + order
				},
				paramsSerializer: params => {
					return qs.stringify(params)
				}
			})
			.then(res => {
				setPrestazioniList(res.data.content);
				setTotalRow(res.data.totalElements);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero delle Prestazioni!');
				console.log(error);
			})
	}

	const getBackofficeInCorso = () => {
		auth.state.axiosInstance?.get('/api/prestazione/numero_mie_prestazioni_in_corso/' + auth.state.puntoServizioLogged?.id)
			.then(res => {
				auth.dispatch({
					type: 'UPDATE_BACKOFFICE_IN_CORSO', payload:
						{
							backofficeInCorso: res.data
						}
				})
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero delle Prestazioni!');
				console.log(error);
			});
	}

	const handleDialogOpen = () => {
		// controllo se e' presente una prestazione con data fine non compilata
		if (prestazioneInCorso !== '') {
			toast.warning('Terminare tutte le prestazioni prima di aggiungerne una nuova!');
		} else {
			setOpenDialog(true);
		}
	}

	const handleDialogClose = (prestazioneDTO?: PrestazioneConfigDTO) => {
		if (prestazioneDTO) {
			const prestazione = {
				id: prestazioneDTO.id,
				name: prestazioneDTO.name,
				codice: prestazioneDTO.codice,
				description: prestazioneDTO.description,
				type: TipoPrestazione.BACKOFFICE,
				cooperativa: auth.state.cooperativa,
				puntoServizioId: auth.state.puntoServizioLogged?.id,
				codiceFiscalePersona: prestazioneDTO.codiceFiscalePersona,
				nomePersona: prestazioneDTO.nomePersona,
				cognomePersona: prestazioneDTO.cognomePersona,
				dataNascitaPersona: prestazioneDTO.dataNascitaPersona !== '' ? dateToIsoMantainTime(prestazioneDTO.dataNascitaPersona) : '',
				sessoPersona: prestazioneDTO.sessoPersona,
			};
			auth.state.axiosInstance?.post('/api/prestazione/insert', prestazione)
				.then(res => {
					setOrder('desc');
					setOrderBy('start_date');
					getAll();
					getBackofficeInCorso();
					if (res.data.cupUrlRedirect != null) {
						window.open(res.data.cupUrlRedirect, '_blank', 'noopener,noreferrer');
					}
				})
				.catch(error => {
					toast.error('🛑 Errore durante il recupero delle Prestazioni!');
					console.log(error);
				});
		}
		setOpenDialog(false);
	}

	const handleDialogOperatoreClose = (prestazioneDTO?: PrestazioneDTO) => {
		if (prestazioneDTO) {
			auth.state.axiosInstance?.put('/api/prestazione/update/' + prestazioneDTO.id, prestazioneDTO)
				.then(res => {
					getAll();
				})
				.catch(error => {
					toast.error('🛑 Errore durante il recupero delle Prestazioni!');
					console.log(error);
				});
		}
		setOpenDialogOperatore(false);
	}

	const handleDialogOperatoreOperatoreOpen = (prestazione: PrestazioneDTO) => {
		setPrestazioneModificaOperatore(prestazione);
		setOpenDialogOperatore(true);
	}

	const handleOperatoreChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newFilter: PrestazioneFilterDTO = {
			statoPrestazione: [...filter.statoPrestazione],
			operatore: event.target.value as string,
			codicePrestazione: filter.codicePrestazione,
			date: filter.date,
			tipoPrestazione: [...filter.tipoPrestazione],
			puntoServizio: filter.puntoServizio
		}
		setFilter(newFilter);
	};

	const handlePuntoServizioChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newFilter: PrestazioneFilterDTO = {
			statoPrestazione: [...filter.statoPrestazione],
			operatore: filter.operatore,
			codicePrestazione: filter.codicePrestazione,
			date: filter.date,
			tipoPrestazione: [...filter.tipoPrestazione],
			puntoServizio: event.target.value as string
		}
		setFilter(newFilter);
	};

	const handleCodiceChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newFilter: PrestazioneFilterDTO = {
			statoPrestazione: [...filter.statoPrestazione],
			operatore: filter.operatore,
			codicePrestazione: event.target.value as string,
			date: filter.date,
			tipoPrestazione: [...filter.tipoPrestazione],
			puntoServizio: filter.puntoServizio
		}
		setFilter(newFilter);
	};

	const handleDataChange = (date: MaterialUiPickersDate, value?: string | null) => {
		const newFilter: PrestazioneFilterDTO = {
			statoPrestazione: [...filter.statoPrestazione],
			operatore: filter.operatore,
			codicePrestazione: filter.codicePrestazione,
			date: date ? date?.toString() : '',
			tipoPrestazione: [...filter.tipoPrestazione],
			puntoServizio: filter.puntoServizio
		}
		setFilter(newFilter);
	};

	const handleSearchClick = () => {
		getAll();
	}

	const handleChangePage = (event: unknown, newPage: number) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const handleEsitoPrestazione = (prestazione: PrestazioneDTO) => {
		auth.state.axiosInstance?.put('/api/prestazione/update/' + prestazione.id, prestazione)
			.then(res => {
				getAll();
				setPrestazioneInCorso('');
				if (res.data.status === ActivityStatus.WAIT) {
					toast.success('Modifiche salvate con successo!');
				} else {
					getBackofficeInCorso();
				}
			})
			.catch(error => {
				toast.error('🛑 Errore durante l\'operazione!');
				console.log(error);
			});
	}

	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				// margin: theme.spacing(1),
				width: '100%',
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);

	const onStartTimer = (prestazione: PrestazioneDTO) => {
		setPrestazioneInCorso(prestazione.id);
	}

	const onStopTimer = (prestazione: PrestazioneDTO) => {
		setPrestazioneInCorso('');
		handleEsitoPrestazione(prestazione);
	}

	const classes = useStyles();

	const navigate = (path: string) => {
		//nothing
	}

	const shouldBlockNavigation = (location: Location): boolean => {
		return prestazioneInCorso !== '';
	}

	return (
		<div>
			<STitleContainer>
				<STitleH3>Operazioni Backoffice in Corso</STitleH3>
			</STitleContainer>
			<SButton className="mb-3"
							 disabled={auth.state.puntoServizioLogged?.puntoServizioConfig || prestazioneInCorso !== ''}
							 onClick={handleDialogOpen}><RiAddFill className="mr-2"/>Aggiungi</SButton>

			{auth.state.puntoServizioLogged?.puntoServizioConfig &&
			<p className="text-danger mt-2">Per poter inserire prestazioni &egrave; necessario effettuare la login in un punto di servizio attivo.</p>
			}
			<Grid container spacing={0} className="w-100 my-4">
				{auth.state.roles && (auth.state.roles.indexOf(UserRole.SUPERVISOR) > -1
					|| auth.state.roles.indexOf(UserRole.RESPONSIBLE) > -1
					|| auth.state.roles.indexOf(UserRole.ADMIN) > -1) &&
				<React.Fragment>
					<Grid item xs={2} className="pr-2">
						<FormControl variant="outlined" className={classes.formControl}>
							<SInputLabel id="canaleAccesso">Operatore</SInputLabel>
							<Select
								required
								labelId="operatore"
								id="operatoreSelect"
								className={classes.selectEmpty}
								label="Operatore"
								value={filter.operatore}
								onChange={handleOperatoreChange}
								MenuProps={{
									anchorOrigin: {
										vertical: "bottom",
										horizontal: "left"
									},
									transformOrigin: {
										vertical: "top",
										horizontal: "left"
									},
									getContentAnchorEl: null
								}}
							>
								<MenuItem value={"ALL"} key={"ALL"}>TUTTI</MenuItem>
								{operatori && operatori.map(op => {
									return (
										<MenuItem value={op.login} key={op.login}>{op.login}</MenuItem>
									)
								})}
							</Select>
						</FormControl>
					</Grid>
					<Grid item xs={2} className="pr-2">
						<FormControl variant="outlined" className={classes.formControl}>
							<SInputLabel id="puntoServizio">Punto di Servizio</SInputLabel>
							<Select
								required
								labelId="puntoServizio"
								id="puntoServizioSelect"
								className={classes.selectEmpty}
								label="Punto di Servizio"
								value={filter.puntoServizio}
								onChange={handlePuntoServizioChange}
								MenuProps={{
									anchorOrigin: {
										vertical: "bottom",
										horizontal: "left"
									},
									transformOrigin: {
										vertical: "top",
										horizontal: "left"
									},
									getContentAnchorEl: null
								}}
							>
								<MenuItem value={"ALL"} key={"ALL"}>TUTTI</MenuItem>
								{puntiServizioList && puntiServizioList.map(op => {
									return (
										<MenuItem value={op.id} key={op.id}>{op.name}</MenuItem>
									)
								})}
							</Select>
						</FormControl>
					</Grid>
				</React.Fragment>

				}
				<Grid item xs={2} className={(auth.state.roles && (
					auth.state.roles.indexOf(UserRole.SUPERVISOR) > -1
					|| auth.state.roles.indexOf(UserRole.RESPONSIBLE) > -1
					|| auth.state.roles.indexOf(UserRole.ADMIN) > -1)) ? "px-2" : "pr-2"}>
					<TextField
						className="w-100"
						id="codice"
						label="Codice Prestazione"
						variant="outlined"
						InputLabelProps={{shrink: true}}
						value={filter.codicePrestazione}
						onChange={handleCodiceChange}
					/>
				</Grid>
				<Grid item xs={2} className="px-2">
					<MuiPickersUtilsProvider utils={LuxonUtils} locale="it-IT">
						<KeyboardDatePicker
							id="date"
							label="Seleziona Data"
							className="w-100"
							variant="inline"
							inputVariant="outlined"
							InputLabelProps={{shrink: true}}
							onChange={handleDataChange}
							format="dd/MM/yyyy"
							okLabel={true}
							error={false}
							value={filter.date}
						/>
					</MuiPickersUtilsProvider>
				</Grid>
				<Grid item xs={2} className="pl-2 d-flex align-items-center">
					<SIconButton onClick={handleSearchClick} disabled={prestazioneInCorso !== ''}><FaSearch className="mx-1"/></SIconButton>
				</Grid>
			</Grid>
			<Paper>
				<TableContainer>
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table">

						<STableHeader
							numSelected={0}
							order={order}
							orderBy={orderBy}
							onRequestSort={handleRequestSort}
							rowCount={totalRow}
							headCells={headCells}
							addCheckbox={false}
							bgcolor="primary"
							sortable={true}
							disableAction={prestazioneInCorso !== ''}
						/>
						<TableBody>
							{prestazioniList &&
							prestazioniList.map((row, index) => {
								const labelId = `enhanced-table-checkbox-${index}`;
								return (
									<PrestazioneContattoRow
										key={row.id}
										row={row}
										labelid={labelId}
										onEsitoOk={handleEsitoPrestazione}
										isBackoffice={true}
										onStartTimer={onStartTimer}
										onStopTimer={onStopTimer}
										disabled={prestazioneInCorso !== row.id || row.operatore !== auth.state.login}
										disabledTimer={prestazioneInCorso !== ''}
										onModificaOperatore={handleDialogOperatoreOperatoreOpen}
									/>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
				<STablePaginationContainer disable={prestazioneInCorso !== ''}>
					<TablePagination
						rowsPerPageOptions={[5, 10, 25]}
						component="div"
						count={totalRow}
						rowsPerPage={rowsPerPage}
						page={page}
						onChangePage={handleChangePage}
						onChangeRowsPerPage={handleChangeRowsPerPage}
						labelRowsPerPage={"Risultati per pagina"}
					/>
				</STablePaginationContainer>
			</Paper>
			<InserimentoPrestazioneDialog open={openDialog} onClose={handleDialogClose} tipoContatto={TipoPrestazione.BACKOFFICE}/>
			<ModificaOperatoreDialog open={openDialogOperatore} onClose={handleDialogOperatoreClose} operatori={operatori} prestazione={prestazioneModificaOperatore}/>
			<RouteLeavingGuard
				when={true}
				navigate={navigate}
				shouldBlockNavigation={shouldBlockNavigation}
				message={"Prima di uscire dalla pagina terminare o mettere in pausa la prestazione in corso!"}
			/>
		</div>
	)
}

interface ModificaOperatoreDialogProps {
	open: boolean;
	prestazione?: PrestazioneDTO;
	operatori: UserDTO[];
	onClose: (prestazione?: PrestazioneDTO) => void;
}

function ModificaOperatoreDialog(props: ModificaOperatoreDialogProps) {
	const {open, prestazione, operatori, onClose} = props;
	const [operatore, setOperatore] = useState<string>((prestazione !== null && prestazione !== undefined) ? prestazione.operatore : '-');

	const handleCancel = () => {
		onClose();
	}

	const handleSave = () => {
		let subTask: SubTaskDTO[] = [];
		if (prestazione !== null && prestazione !== undefined) {
			subTask = [...prestazione.subTask];
		}
		let newPrest: PrestazioneDTO = {
			id: (prestazione !== null && prestazione !== undefined) ? prestazione.id : '',
			name: (prestazione !== null && prestazione !== undefined) ? prestazione.name : '',
			operatore: operatore,
			codice: (prestazione !== null && prestazione !== undefined) ? prestazione.codice : '',
			cooperativa: (prestazione !== null && prestazione !== undefined) ? prestazione.cooperativa : '',
			origin: (prestazione !== null && prestazione !== undefined) ? prestazione.origin : '',
			type: (prestazione !== null && prestazione !== undefined) ? prestazione.type : '',
			startDate: (prestazione !== null && prestazione !== undefined) ? prestazione.startDate : '',
			endDate: (prestazione !== null && prestazione !== undefined) ? prestazione.endDate : '',
			status: (prestazione !== null && prestazione !== undefined) ? prestazione.status : '',
			accesso: (prestazione !== null && prestazione !== undefined) ? prestazione.accesso : '',
			subTask: subTask,
			note: (prestazione !== null && prestazione !== undefined) ? prestazione.note : '',
			createdBy: (prestazione !== null && prestazione !== undefined) ? prestazione.createdBy : '',
			createdDate: (prestazione !== null && prestazione !== undefined) ? prestazione.createdDate : '',
			lastModifiedBy: (prestazione !== null && prestazione !== undefined) ? prestazione.lastModifiedBy : '',
			lastModifiedDate: (prestazione !== null && prestazione !== undefined) ? prestazione.lastModifiedDate : '',
			description: (prestazione !== null && prestazione !== undefined) ? prestazione.description : '',
			duration: (prestazione !== null && prestazione !== undefined) ? prestazione.duration : 0,
			idContatto: (prestazione !== null && prestazione !== undefined) ? prestazione.idContatto : '',
			notaStatus: (prestazione !== null && prestazione !== undefined) ? prestazione.notaStatus : '',
			boOpzionali: (prestazione !== null && prestazione !== undefined) ? prestazione.boOpzionali : [],
			boObbligatori: (prestazione !== null && prestazione !== undefined) ? prestazione.boObbligatori : [],
			tipoFrontOffice: (prestazione !== null && prestazione !== undefined) ? prestazione.tipoFrontOffice : '',
			puntoServizioId: (prestazione !== null && prestazione !== undefined) ? prestazione.puntoServizioId : '',
			puntoServizioName: (prestazione !== null && prestazione !== undefined) ? prestazione.puntoServizioName : ''
		};
		onClose(newPrest);
	}

	const handleOperatoreChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		setOperatore(event.target.value as string);
	};

	useEffect(() => {
	}, [operatore]);

	useEffect(() => {
		setOperatore((prestazione !== null && prestazione !== undefined) ? prestazione.operatore : '-');
	}, [open]);

	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				// margin: theme.spacing(1),
				width: '100%',
				margin: '1rem 0'
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);

	const classes = useStyles();

	return (
		<div>
			<Dialog
				open={open}
				onClose={handleCancel}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				maxWidth="sm"
				fullWidth={true}
			>
				{/*<DialogTitle id="alert-dialog-title">{(prestazione !== null && prestazione !== undefined) ? prestazione.name : '-'}</DialogTitle>*/}
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						<h4 className="mb-0 text-dark">{(prestazione !== null && prestazione !== undefined) ? prestazione.name : '-'}</h4>
						<h6 className="mt-0 mb-4 text-dark">{(prestazione !== null && prestazione !== undefined) ? prestazione.description : '-'}</h6>
						<div className="mx-3 mb-3">
							<h5>Stato Attivit&agrave;: IN ATTESA</h5>
							<h5>Note: {(prestazione !== null && prestazione !== undefined) ? prestazione.note : '-'}</h5>
							<h5>Operatore Incaricato: {operatore}</h5>
						</div>
						{(!operatori || operatori.length === 0) &&
						<p className="mx-3 text-danger">Operazione non consentita. Nessun operatore associato al punto di servizio '{prestazione?.puntoServizioName}'.</p>
						}
						<FormControl variant="outlined" className={classes.formControl} disabled={!operatori || operatori.length === 0}>
							<SInputLabel id="canaleAccesso">Cambia Operatore</SInputLabel>
							<Select
								required
								labelId="operatore"
								id="operatoreSelect"
								className={classes.selectEmpty}
								label="Cambia Operatore"
								value={operatore}
								onChange={handleOperatoreChange}
								MenuProps={{
									anchorOrigin: {
										vertical: "bottom",
										horizontal: "left"
									},
									transformOrigin: {
										vertical: "top",
										horizontal: "left"
									},
									getContentAnchorEl: null
								}}
							>
								{/*<MenuItem value={"ALL"} key={"ALL"}>TUTTI</MenuItem>*/}
								{operatori && operatori.map(op => {
									return (
										<MenuItem value={op.login} key={op.id}>{op.login}</MenuItem>
									)
								})}
							</Select>
						</FormControl>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<SButton onClick={handleSave} variant="blu" disabled={!operatori || operatori.length === 0}>
						MODIFICA
					</SButton>
					<SButton onClick={handleCancel} variant="secondary">
						ANNULLA
					</SButton>
				</DialogActions>
			</Dialog>
		</div>
	);
}
